export default "__VITE_ASSET__CtPGnpj5__"